/*
    Imports Vue and Vuex
*/
import Vue from 'vue'
import Vuex from 'vuex'
import bibles from './modules/Bibles'
import users from './modules/Users'
import configuration from './modules/Configuration'
import 'es6-promise/auto'
/*
    Initializes Vuex on Vue.
*/
Vue.use( Vuex )

export default new Vuex.Store({
    state: () => ({
        notification: {
            title: "",
            msg: "",
            filled: false,
            success: false,
            error: false,
            warning: false,
            active: false,
        },
    }),
    getters:{
        getNotification(state) {
            return state.notification;
        },
    },
    mutations:{
        setNotification(state, notification) {
            state.notification = notification;
        },
    },
    actions:{
        closeNotification({ commit }) {
            commit('setNotification', {
              active: false,
            });
        },
    },
    modules: {
        bibles,
        users,
        configuration
    }
})